// External Dependencies
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Components
import Navigation from './components/Navigation';

// Pages
import Landing from './pages/Landing';
import Chat from './pages/Chat';
import About from './pages/About';
import LearnMore from './pages/LearnMore';
import Generation from './pages/Generation';
import ImageGeneration from './pages/ImageGeneration';
import VideoGeneration from './pages/VideoGeneration';
import TextGeneration from './pages/TextGeneration';
import CodeGeneration from './pages/CodeGeneration';
import HDPhotoGeneration from './pages/HDPhotoGeneration';
import AnimeGeneration from './pages/AnimeGeneration';

// Context
import { LoadingProvider } from './context/LoadingContext';

import './styles/scrollbar.css';

export default function App() {
  return (
    <LoadingProvider>
      <Router>
        <div className="min-h-screen bg-gray-900 text-white">
          <Navigation />
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/about" element={<About />} />
              <Route path="/learn-more" element={<LearnMore />} />
              <Route path="/generation" element={<Generation />} />
              <Route path="/image-generation" element={<ImageGeneration />} />
              <Route path="/video-generation" element={<VideoGeneration />} />
              <Route path="/text-generation" element={<TextGeneration />} />
              <Route path="/code-generation" element={<CodeGeneration />} />
              <Route path="/photo-hd" element={<HDPhotoGeneration />} />
              <Route path="/photo-anime" element={<AnimeGeneration />} />
              <Route path="*" element={<Landing />} />
            </Routes>
          </main>
        </div>
      </Router>
    </LoadingProvider>
  );
}
